import { FC } from 'react';
import ISvgProps from '../SvgLoader/ISvgProps';

export const ExpiredLinkMobileIcon: FC<ISvgProps> = ({ primaryColor = '#191919' }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
			<circle cx="32" cy="32" r="32" fill="url(#paint0_linear_1448_4843)" fillOpacity="0.5" />
			<path
				d="M19.3335 42.932H44.6668V44.6654H19.3335V42.932ZM22.6668 31.9987H24.4002V40.8654H22.6668V31.9987ZM29.0002 31.9987H30.7335V40.8654H29.0002V31.9987ZM34.0668 31.9987H35.8002V40.8654H34.0668V31.9987ZM39.6002 31.9987H41.3335V40.8654H39.6002V31.9987ZM19.3335 25.6654L32.0002 19.332L44.6668 25.6654V30.732H19.3335V25.6654ZM21.0668 27.231V28.9987H42.9335V27.231L32.0002 21.3643L21.0668 27.231ZM32.0002 26.932C31.6642 26.932 31.342 26.7986 31.1045 26.561C30.8669 26.3235 30.7335 26.0013 30.7335 25.6654C30.7335 25.3294 30.8669 25.0072 31.1045 24.7697C31.342 24.5322 31.6642 24.3987 32.0002 24.3987C32.3361 24.3987 32.6583 24.5322 32.8958 24.7697C33.1334 25.0072 33.2668 25.3294 33.2668 25.6654C33.2668 26.0013 33.1334 26.3235 32.8958 26.561C32.6583 26.7986 32.3361 26.932 32.0002 26.932Z"
				fill="#44345E"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1448_4843"
					x1="32"
					y1="0"
					x2="32"
					y2="64"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#BF9CFA" stopOpacity="0.6" />
					<stop offset="1" stopColor="#8A43FF" stopOpacity="0.8" />
				</linearGradient>
			</defs>
		</svg>
	);
};
